import React from 'react';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginBG, Logo } from '../../assets/images';
import { IconRegisterSchool, IconRegisterTeacher } from '../../assets/icons';

const Register = () => {

  const navigate = useNavigate();

  return (
    <div className="flex flex-row h-screen">
      <div className="login-bg hidden md:w-1/2 md:flex justify-center items-center">
        <img src={LoginBG} className="object-cover w-full h-full" alt="" />
      </div>
      <div className="relative w-full md:w-1/2 flex flex-col items-center">
        <div className="absolute z-10 left-4 top-4 cursor-pointer" onClick={() => navigate('/login', { replace: true })}>
          <IconArrowLeft />
        </div>

          <main className="relative w-full md:w-[40%] px-4 md:px-0 flex flex-1 flex-col justify-center items-center">
            <img className="max-w-[75%] h-24 object-contain mb-4" src={Logo} alt="Logo" />

            <p>Selecciona el tipo de registro</p>

            <Link
              className="w-full bg-white mt-8 flex flex-row items-center gap-4 p-1 rounded-md shadow-lg shadow-primary-200/40"
              to="/register/school"
            >
              <div className="w-12 h-12 flex justify-center items-center rounded bg-green/30">
                <img className="w-10 object-contain" src={IconRegisterSchool} alt="Registrar Colegio" />
              </div>
              <span className="font-semibold">Colegio</span>
            </Link>

            <Link
              className="w-full bg-white mt-8 flex flex-row items-center gap-4 p-1 rounded-md shadow-lg shadow-primary-200/40"
              to="/register/teacher"
            >
              <div className="w-12 h-12 flex justify-center items-center rounded bg-blue/30">
                <img className="w-10 object-contain" src={IconRegisterTeacher} alt="Registrar Profesor" />
              </div>
              <span className="font-semibold">Profesor</span>
            </Link>
          </main>
      </div>
    </div>
  )
}

export default Register;